import Header from '../components/HeaderLogin'
import SignUp from "../components/SignUp";
import "./SignUp.css";

const Login = () => {
  
  return (
    <div className="mainFrame">
      <Header/>
      <SignUp/>
    </div>
  );
};

export default Login;